"use strict";

REATOA.pageScript = REATOA.pageScript || {
  init: {}
};
REATOA.pageScript = function () {
  // コンストラクタ  =================================================================
  function init() {
    console.log('other.js');
  }
  return {
    init: init
  };
}();
REATOA.common.init(REATOA.pageScript.init);